import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    ElementoSeccion: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_ELEMENTOS_SECCION = 'GET_ALL_ELEMENTOS_SECCION'
const GET_ELEMENTO_SECCION_BY_ID = 'GET_ELEMENTO_SECCION_BY_ID'
const GET_ELEMENTO_SECCION_BY_ID_TIPO_AREA = 'GET_ELEMENTO_SECCION_BY_ID_TIPO_AREA'
const POST_ELEMENTO_SECCION = 'POST_ELEMENTO_SECCION'
const UPDATE_ELEMENTO_SECCION = 'UPDATE_ELEMENTO_SECCION'
const DELETE_ELEMENTO_SECCION = 'DELETE_ELEMENTO_SECCION'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllElementosSeccion = createAsyncThunk(
    GET_ALL_ELEMENTOS_SECCION,
    async () => {
        try {
            const fullUrl = host + `ElementoSeccion/obtenerElementosSeccion`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las ElementoSeccions: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getElementoSeccionById = createAsyncThunk(
    GET_ELEMENTO_SECCION_BY_ID,
    async (idElementoSeccion) => {
        try {
            const fullUrl = host + `ElementoSeccion/obtenerElementoSeccionById/${idElementoSeccion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getElementoSeccionByIdArea = createAsyncThunk(
    GET_ELEMENTO_SECCION_BY_ID_TIPO_AREA,
    async (idArea) => {
        try {
            const fullUrl = host + `ElementoSeccion/obtenerElementoSeccionByIdArea/${idArea}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertElementoSeccion = createAsyncThunk(
    POST_ELEMENTO_SECCION,
    async (data) => {
        try {
            const fullUrl = host + `ElementoSeccion/agregarElementoSeccion`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateElementoSeccion = createAsyncThunk(
    UPDATE_ELEMENTO_SECCION,
    async (data) => {
        try {
            const fullUrl = host + `ElementoSeccion/actualizarElementoSeccion`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteElementoSeccion = createAsyncThunk(
    DELETE_ELEMENTO_SECCION,
    async (idElementoSeccion) => {
        try {
            const fullUrl = host + `ElementoSeccion/eliminarElementoSeccion/${idElementoSeccion}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosElementoSeccionSlice = createSlice({

    name: 'metodosElementoSeccionSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllElementosSeccion.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.ElementoSeccion = payload.data.data

        },
        [getElementoSeccionById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.ElementoSeccion = payload.data.data
        },
        [getElementoSeccionByIdArea.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.ElementoSeccion = payload.data.data
        },
        [insertElementoSeccion.fulfilled]: (state, { payload }) => {
            state.ElementoSeccion = payload.data.data
        },

        [updateElementoSeccion.fulfilled]: (state, { payload }) => {

        },
        [deleteElementoSeccion.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosElementoSeccionSlice.actions
export const ElementoSeccionReducer = metodosElementoSeccionSlice.reducer